import { makeHook } from "../../utils/makeSingleArgHook";
import getAssetClasses, { assetClassesUrl, } from "../request/getAssetClasses";
export const assetClassesKeyMaker = (personId) => [
    assetClassesUrl(personId),
];
const useGetAssetClasses = makeHook(getAssetClasses, assetClassesKeyMaker);
export default useGetAssetClasses;
//# sourceMappingURL=useGetAssetClasses.js.map